import React from 'react';
import { motion } from 'framer-motion';
const situations = [{
  emoji: '🔩',
  title: 'La Mañana del Clavo',
  text: 'Bajás los pies de la cama y... el pinchazo. Caminás en puntas de pie hasta el baño como si tuvieras 90 años. Lo peor: ya te acostumbraste.'
}, {
  emoji: '⚽',
  title: 'El Vestuario',
  text: 'Los pibes festejando y vos sentado en el banco, sacándote la bota con cuidado. Ya no sos el que juega hasta el final. Sos el que "cuida el pie".'
}, {
  emoji: '🗄️',
  title: 'El Cajón de las Plantillas',
  text: 'Plantillas de gel, magnéticas, de carbono. Más de $50.000 en parches. Todas prometían lo mismo. Ninguna resolvió nada.'
}, {
  emoji: '😔',
  title: 'La Resignación',
  text: '"Descansá dos semanas". Descansaste. Volviste. El dolor volvió. Te dijiste: "Capaz que a mi edad, esto es lo que hay." No es verdad. Es que no tuviste el método correcto.'
}];
export function PainSection() {
  return <section className="py-6 md:py-10 px-4" data-id="element-120">
      <div className="max-w-4xl mx-auto" data-id="element-121">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl md:text-2xl font-black uppercase text-white text-center mb-4" data-id="element-122">
          ¿Te suena familiar?
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-123">
          {situations.map((s, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-dark-card border border-dark-border rounded-xl p-4" data-id="element-124">
              <div className="flex items-center gap-2 mb-2" data-id="element-125">
                <span className="text-2xl" data-id="element-126">{s.emoji}</span>
                <h3 className="text-base font-black text-white uppercase" data-id="element-127">
                  {s.title}
                </h3>
              </div>
              <p className="text-white text-base md:text-lg leading-relaxed" data-id="element-128">
                {s.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}